import { useEffect, useState } from "react"
import { SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"
import DataListModal from "../../DataModals/DataListModal"
import * as Basic from "../../../Modules/BasicFields"

export default function CharacterSheet( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const modalOpen = props.modalOpen
    const selected = props.selected
    const reset = props.reset

    const requiredData = [
    ]

    const cfgName = "echo_chambers_the_constellation_cfg"


    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}
    }

    useEffect( () => {
        reload()
    },[])

    /*useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }
        
        let data = {}

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ font, hashtag, hashtagRate, list ])*/

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
        </>
    )
}
